import { cn } from "../lib/cn";

export interface ActiveStripeProps {
	/** Отступ полосы от верха и низа строки. По умолчанию — витринные 8px. */
	className?: string;
}

/**
 * Маркер «где я» — зелёная полоса 4px у левого края строки меню.
 *
 * Одна из трёх работ бренд-цвета по брифу (заливка primary · «где я» ·
 * акценты идентичности), и единственная его форма в навигации. Цвет берётся
 * из `--accent-active` (`#52DD2B`), а не из литерала: полоса и заливка кнопки
 * — разные оттенки одного бренда, и разъезжаются они молча.
 *
 * ПОЧЕМУ ОТДЕЛЬНЫМ КОМПОНЕНТОМ. Полосу рисовали в двух местах своей разметкой:
 * `NavItem` (кит, `marker="stripe"`) и `AdminNavAnchor` (админка, у неё своя
 * геометрия строки — 40px без плашки под глифом, поэтому `NavItem` ей не
 * подошёл). Две копии канонического маркера — это ровно тот случай, когда
 * второй источник правды сходится с первым до первой правки токена.
 *
 * `aria-hidden` намеренно: состояние «текущий раздел» доносит `aria-current`
 * на самой ссылке, а вторым объявлением полосы скринридер получил бы дубль.
 */
export function ActiveStripe({ className }: ActiveStripeProps) {
	return (
		<span
			aria-hidden="true"
			className={cn(
				"absolute inset-y-2 left-0 w-1 rounded-r-full bg-[var(--accent-active)]",
				className,
			)}
		/>
	);
}
